<template>
  <div
    :class="`c-toggle-button ${active ? 'c-toggle-button--active' : ''}`"
    @click="onChangeStatus"
  >
    <span
      class="c-toggle-button__circle"
    ></span>
  </div>
</template>

<script>
export default {
  name: 'ToggleButton',
  props: {
    active: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    onChangeStatus() {
      this.$emit('change-status');
    }
  },
};
</script>

<style lang="scss" scoped>

.c-toggle-button {
  position: relative;
  cursor: pointer;
  display: inline-block;
  width: rem(44px);
  height: rem(26px);
  border-radius: rem(13px);
  border: 1px solid;

  @include themify($themes) {
    background-color: themed('background', 'base');
    border-color: themed('background', 'dark');
  }

  &--active {
    @include themify($themes) {
      background-color: themed('background', 'dark');
    }
  }
}

.c-toggle-button__circle {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  display: inline-block;
  width: rem(24px);
  height: rem(24px);
  border-radius: rem(12px);
  box-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);

  @include themify($themes) {
    background-color: themed('background', 'select');
  }
}

.c-toggle-button--active .c-toggle-button__circle {
  left: 100%;
  transform: translate(-100%, -50%);
}
</style>
